import React from 'react';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

export default class CancelTest extends React.PureComponent {

  render() {
    const { open, item, handleCancel } = this.props;

    return (
      <div>
        <Dialog
          open={open}
          onClose={handleCancel}
          aria-labelledby="form-dialog-title"
          fullWidth={true}
          maxWidth='xs'
        >
          <DialogTitle id="form-dialog-title">Cancelación del Test</DialogTitle>
          <DialogContent>
            <DialogContentText>
            ¿Estás seguro que quieres cancelar el test y perder la retribución?
            </DialogContentText>
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="*Cuéntanos el motivo…"
              type="email"
              fullWidth
              multiline={true}
              rows={3}
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCancel} color="secondary">
              No
            </Button>
            <Button onClick={handleCancel} color="primary">
              Sí Cancelar
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/modules/test/components/Dialogs/CancelTest.js